import { Injectable, Inject } from '@angular/core';
import { PropertyAddressDO } from './PropertyAddress.model';
import { BaseDO } from './base.model';

export class PropertyDO extends BaseDO {
    public id: Number = null;
    public builtYear: Number = null;
    public storeys: Number = null;
    public constructionTypeCd: String = null;
    public constructionClassCd: String = null;
    public ownershipCd: String = null;
    public occupationCd: String = null;
    public occupationClassCd: String = null;
    public ristCategoryCd: String = null;
    public eqZoneCd: String = null;
    public floodZoneCd: String = null;
    public crestaZoneCd: String = null;
    public maiparkZoneCd: String = null;
    public propertyAddressDO: PropertyAddressDO = new PropertyAddressDO();
    public indemnityPeriod: String = null;
}
